import axios from "axios";
import { commentsSlice, callTypes } from "./commentsSlice";

const API_URL = process.env.REACT_APP_API_URL;
const { actions } = commentsSlice;

export const fetchComments = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  return axios
    .get(API_URL + "comments/all", { params: { _limit: -1 } })
    .then((response) =>
      dispatch(actions.commentsFetched({ commentsList: response.data }))
    )
    .catch((err) =>
      dispatch(actions.catchError({ error: err, callType: callTypes.list }))
    );
};

export const hideComments = (commentsReport) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.hide }));

  const body = {
    reason: commentsReport.reasons,
    comment: commentsReport.comments,
    send_pn: commentsReport.notifications.includes("Send push"),
    send_email: commentsReport.notifications.includes("Send email"),
  };
  return axios
    .put(API_URL + `comments/${commentsReport.id}/hide`, body)
    .then((response) => {
      dispatch(actions.commentHided({ commentHided: response.data }));
    })
    .catch((err) =>
      dispatch(actions.catchError({ error: err, callType: callTypes.hide }))
    );
};
